export const formatDate = (date: string): string => {
    const datevar = new Date(date);
    const options: Intl.DateTimeFormatOptions = { day: "2-digit", month: "long", year: "numeric" };
    return datevar.toLocaleDateString("en-GB", options);
};

export const formatTime = (time: string): string => {
  const datePrefix = "1970-01-01";
  const fullDateTime = new Date(`${datePrefix}T${time}`);
  return fullDateTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};
